// @flow weak

import React, {
  Component
}                     from 'react';
import PropTypes      from 'prop-types';
var Spinner = require('react-spinkit');
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {
  StatsTable,AnimatedView
}                         from '../../components';





class GameTypeTab extends Component {


  state = {
    game_types: [
      {name: 'F-Imp', id:2 },
      {name: 'F-Play', id:1 },
      {name: 'F-Academy', id:8 },
      {name: 'F-Rent', id:12 },
      {name: 'F-Tour', id:13 },
      {name: 'B-Imp', id:4 },
      {name: 'B-Play', id:3 },
      {name: 'B-Rent', id:18 },
      {name: 'B-Academy', id:10 },
      {name: 'B-Tour', id:14 },    
      {name: 'F-Summer', id: 16},
      {name: 'B-Summer', id: 17},
    ]    
  };   

  constructor(props) {
    super(props);
  }



  componentDidMount() {
  }

  componentWillReceiveProps(newProps) {  
  }


  render() {
    var tabHeaders = [];
    for (var i = 0; i < this.state.game_types.length; i++) {
      tabHeaders.push(<Tab key={i}>{this.state.game_types[i].name}</Tab>);
    }

    var tabContents = [];
    for (var i = 0; i < this.state.game_types.length; i++) {
      tabContents.push(<TabPanel key={i}><StatsTable nonCollapsible={true} game_type_id={this.state.game_types[i].id}  name={this.props.name} data={this.props.data} reloadData={this.props.reloadData} bigTable={this.props.bigTable}/></TabPanel>);
    }    

    return (

            <div>
              <div className="collapsibile-table-heading table-heading" style={{cursor: 'pointer'}} data-toggle="collapse" href={"#"+this.props.name}>
                <div className="table-header"><span>{this.props.displayName}</span></div>                
              </div>

              <div id={this.props.name} className="collapse">
                <Tabs>
                  <TabList>
                    {tabHeaders}
                  </TabList>

                    {tabContents}
                </Tabs>
              </div>
            </div>


    );      
  }
}

export default GameTypeTab



// WEBPACK FOOTER //
// ./src/app/components/gameTypeTab/GameTypeTab.js